import React from 'react';
import css from './tasklist.module.scss';

interface Task {
  completed: boolean;
  text: string;
}

interface TaskListProps {
  tasks: Array<Task>;
}

export default function TaskList({ tasks }: TaskListProps) {
  return (
    <ul className={css.taskList}>
      {tasks.map((task: Task, index: number) => {
        const checkmark = task.completed ? (
          <img src="/static/teal-check.svg" alt="" />
        ) : (
          ''
        );

        const completedStyle = task.completed ? '' : css.incomplete;
        return (
          <li className={css.task} key={task.text + index}>
            <div>{checkmark}</div>
            <p className={completedStyle}>{task.text}</p>
          </li>
        );
      })}
    </ul>
  );
}
